import { HOME_DASHBOARD_SECTION_LABELS } from '../../../utils/dashboard/homeDashboardLayout';

const GHOST_BODY_MIN_PX = 88;
const GHOST_BODY_MAX_PX = 168;

const createDashboardLayoutSectionDragGhost = (handleEl, event, sectionId) => {
	const sectionEl = handleEl?.closest?.('.dashboard-layout-section') ?? handleEl;
	const rect = (sectionEl instanceof Element ? sectionEl : handleEl).getBoundingClientRect();
	const label = HOME_DASHBOARD_SECTION_LABELS[sectionId] ?? sectionId;
	const bodyEl = sectionEl instanceof Element ? sectionEl.querySelector('.dashboard-layout-section__body') : null;
	const bodyHeight = bodyEl instanceof Element ? bodyEl.getBoundingClientRect().height : rect.height;
	const previewHeight = Math.round(Math.min(GHOST_BODY_MAX_PX, Math.max(GHOST_BODY_MIN_PX, bodyHeight * 0.34)));

	const host = document.createElement('div');
	host.className = 'dashboard-layout-section__drag-ghost-host';
	host.style.position = 'fixed';
	host.style.top = '-9999px';
	host.style.left = '0';
	host.style.zIndex = '10000';
	host.style.pointerEvents = 'none';

	const bsTheme = document.documentElement.getAttribute('data-bs-theme');
	if (bsTheme) {
		host.setAttribute('data-bs-theme', bsTheme);
	}

	const ghost = document.createElement('article');
	ghost.className = 'dashboard-layout-section dashboard-layout-section__drag-ghost';
	ghost.style.width = `${Math.round(rect.width)}px`;

	const chrome = document.createElement('header');
	chrome.className = 'dashboard-layout-section__chrome';

	const handle = document.createElement('div');
	handle.className = 'dashboard-layout-section__drag-handle';

	const grip = document.createElement('i');
	grip.className = 'fas fa-grip-lines';
	grip.setAttribute('aria-hidden', 'true');

	const labelNode = document.createElement('span');
	labelNode.className = 'dashboard-layout-section__label';
	labelNode.textContent = label;

	handle.append(grip, labelNode);
	chrome.appendChild(handle);

	const preview = document.createElement('div');
	preview.className = 'dashboard-layout-section__drag-ghost-body';
	preview.style.height = `${previewHeight}px`;
	preview.setAttribute('aria-hidden', 'true');

	ghost.append(chrome, preview);
	host.appendChild(ghost);
	document.body.appendChild(host);
	void host.offsetHeight;

	const ghostRect = host.getBoundingClientRect();
	const offsetX = Math.min(Math.max(event.clientX - rect.left, 20), Math.max(rect.width - 20, 20));
	const clickYInSection = event.clientY - rect.top;
	const offsetY = Math.min(Math.max(clickYInSection, 12), Math.max(ghostRect.height - 12, 12));

	return { host, offsetX, offsetY };
};

export default createDashboardLayoutSectionDragGhost;
